import type { BrandingConfig } from '@/types/database/portal-types';

export type NavIconButtonVariant = 'icon' | 'icon-secondary';

/** Product nav-bar soft icon treatment from org branding. */
export function navIconButtonVariant(
  branding?: Pick<BrandingConfig, 'use_secondary_color_in_nav_bar'> | null,
): NavIconButtonVariant {
  return branding?.use_secondary_color_in_nav_bar === true ? 'icon-secondary' : 'icon';
}
